import { Node, Edge } from "@xyflow/react";
import { layoutCampaignGraph } from "@signalist/shared-types";

import { MyNode, NodeData } from "../types/node-data.types";

/**
 * Lays the campaign graph out as a tidy tree: every step one row below its parent, every parent
 * centred over its children, each subtree in a band of its own. The algorithm lives in
 * @signalist/shared-types (`layoutCampaignGraph`), so a campaign built outside the builder (the MCP
 * sequence converter, PREC-4258) is laid out exactly as the builder lays it out. Parentage comes
 * from `edges` only; `data.source` / `data.edgeType` go stale (see the shared function's docblock).
 */
export function autoLayoutHorizontal(nodes: Node<NodeData>[], edges: Edge[]): MyNode[] {
	return layoutCampaignGraph(nodes, edges) as unknown as MyNode[];
}
